import { ConstantsCodeType } from 'src/types/constantsCodes';

/** Stejné hodnoty jako v Selectu typu produktu (OthersTable). */
export const integrationProductTypeOptions: ConstantsCodeType[] = [
    { value: 'czechFifoProductDefaults', label: 'CZK + FIFO (First In First Out)' },
    { value: 'eurFifoProductDefaults', label: 'EUR + FIFO (First In First Out)' },
    { value: 'czechFefoProductDefaults', label: 'CZK + FEFO (First Expired First Out)' },
    { value: 'eurFefoProductDefaults', label: 'EUR + FEFO (First Expired First Out)' }
];

/** Stejné jako v OthersTable – Select sloupce KEY u Retina. */
export const integrationRetinoKeyOptions: ConstantsCodeType[] = [
    { value: 'RETINO_ITEM_TYPE', label: 'RETINO_ITEM_TYPE' },
    { value: 'RETINO_CONFIRMED_TAG_NAME', label: 'RETINO_CONFIRMED_TAG_NAME' },
    { value: 'RETINO_DESCRIPTION_FIELD', label: 'RETINO_DESCRIPTION_FIELD' },
    { value: 'RETINO_RETURN_REASON_FIELD', label: 'RETINO_RETURN_REASON_FIELD' },
    { value: 'RETINO_RETURN_REASON_VALUE', label: 'RETINO_RETURN_REASON_VALUE' },
    { value: 'RETINO_SHIPPING_PAID_BY', label: 'RETINO_SHIPPING_PAID_BY' }
];
